import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import PanelBarViewModelType from '@/ViewModels/Controls/PanelBarViewModel';
import NavigationService from '@/Management/NavigationService';

export default class PanelBar extends Control {

    private jQueryControl: JQuery;
    public isReady: JQueryDeferred<boolean>;
    public isFancytreeRendered: JQueryDeferred<JQuery>;
    private interval: number = null;

    /**
     * @override
     */
    public widget: KnockoutObservable<kendo.ui.PanelBar>;

    public constructor(private viewModel: PanelBarViewModelType, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));

        this.isReady = $.Deferred();
        this.isFancytreeRendered = $.Deferred();
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<ul>');

        this.applyBindings(this.jQueryControl, {
            kendoPanelBar: {
                animation: this.viewModel.animation,
                expandMode: 'multiple',
                widget: this.widget
            }
        });

        // when control is ready poll the navigation
        this.isReady.then(() => {
            this.interval = window.setInterval(this.checkForFancytree.bind(this), 100);
        });

        this.isFancytreeRendered.then(($tree) => {
            this.resize($tree);
            this.addHotkey();

            // re-calculate navigation-height when window is resizing
            this.addEventHandler('resize', $(window), this.resize.bind(this, $tree));
        });

        this.async(() => { clearInterval(this.interval); }, 5000);

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: kendo.ui.PanelBar): void {
        widget.expand(this.jQueryControl.children(), true);
        this.applyBindings(this.jQueryControl, {
            controlName: 'panelbar',
            loader: this.viewModel.isBusy,
            controlIdent: this.identifier,
            tooltip: this.viewModel.tooltip,
            invalid: this.viewModel.invalidationText,
            visible: this.viewModel.isVisible,
            panelBarItems: {
                parent: this,
                items: this.viewModel.items,
                widget: this.widget
            },
            styles: this.definePureComputed({
                read: () => {
                    let styles = ['default'];
                    return styles;
                }
            }),
            states: this.definePureComputed({
                read: () => {
                    let states = [];
                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    return states;
                }
            })
        });

        this.isReady.resolve(true);
    }

    public addHotkey() {
        let $input = this.jQueryControl.find('.panelbar-searchfield').children('input');
        let isolatedViewFactoryCount = NavigationService.getInstance().getModalViewFactories();

        this.applyBindings(this.jQueryControl, {
            hotkey: {
                shortcut: 'alt+m',
                handler: () => {
                    if (isolatedViewFactoryCount == NavigationService.getInstance().getModalViewFactories()) {
                        $input.focus();
                    }
                    return false;
                }
            }
        });
    }

    public checkForFancytree() {
        let $tree = this.jQueryControl.find('.c-fancytree');
        if ($tree.length < 1) {
            return;
        }

        clearInterval(this.interval);
        this.isFancytreeRendered.resolve($tree);
    }

    public resize($tree: JQuery) {
        let elementHeight = this.jQueryControl.height();
        let searchFieldHeight = this.jQueryControl.find('.panelbar-searchfield').height();
        let newHeight = elementHeight - searchFieldHeight;

        $tree.height(newHeight);
    }
}

ComponentManager.setControl('PanelBar', PanelBar, 'RADPresentation.HTMLClient.DefaultViewExtensions');